import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NgbModalModule, NgbModule, NgbPaginationModule} from "@ng-bootstrap/ng-bootstrap";
import {NgMultiSelectDropDownModule} from '../../LibrerieCustom/MultiselectDropdown'
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FeatherModule} from "angular-feather";
import {RouterModule} from "@angular/router";
import {SharedModule} from "../shared/Shared.module";
import {icons} from "../shared/icon";
import { RmaListComponent } from './rma-list/rma-list.component';
import { RmaEditComponent } from './rma-edit/rma-edit.component';
import { RmaCalendarComponent } from './rma-calendar/rma-calendar.component';
import { RmaProdottoAddComponent } from './rma-add/rma-prodotto-add.component';
import {StampeModule} from "../Stampe/Stampe.module";
import {TranslateModule} from "@ngx-translate/core";
import { VociCostoComponent } from './voci-costo/voci-costo.component';
import { AttivitaRmaComponent } from './attivita-rma/attivita-rma.component';
import { EditAttivitaRmaComponent } from './edit-attivita-rma/edit-attivita-rma.component';
import {MappaModule} from "../mappa/mappa.module";
import {PdfViewerModule} from 'ng2-pdf-viewer';
import { ListaProvaAcquistoComponent } from './lista-prova-acquisto/lista-prova-acquisto.component';
import { EditProvaAcquistoComponent } from './edit-prova-acquisto/edit-prova-acquisto.component';
import {EsitiRmaComponent} from "./EsitiRma/esiti-rma.component";
import {EditEsitiRmaComponent} from "./edit-esiti-rma/edit-esiti-rma.component";
import { SelectDocModelComponent } from './select-doc-model/select-doc-model.component';
import {PATicketComponent} from "./pa-ticket/pa-ticket.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {TooltipModule} from "ngx-bootstrap/tooltip";
export const routes = [
  {
    path: 'cliente/list',
    data: {
      title: "Rma",
      urls: [{ title: "Rma" }],
    },
    component: RmaListComponent,
  },
  {
    path: 'edit',
    data: {
      title: "Rma",
      urls: [{ title: "Rma" }],
    },
    component: RmaEditComponent,
  },
  {
    path: 'edit/:rma_id',
    data: {
      title: "Rma",
      urls: [{ title: "Rma" }],
    },
    component: RmaEditComponent,
  },
    {
        path: 'proveacquisto/list',
        data: {
            title: "Prodotto",
            urls: [{ title: "Prodotto" }],
        },
        component: ListaProvaAcquistoComponent,
    },

];
@NgModule({
    declarations: [
      RmaListComponent,
      RmaEditComponent,
      RmaCalendarComponent,
      RmaProdottoAddComponent,
      VociCostoComponent,
      AttivitaRmaComponent,
      EditAttivitaRmaComponent,
      ListaProvaAcquistoComponent,
      EditProvaAcquistoComponent,
      EsitiRmaComponent,
      EditEsitiRmaComponent,
      SelectDocModelComponent,

    ],
    exports: [
        RmaListComponent,
        ListaProvaAcquistoComponent,
        AttivitaRmaComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        NgMultiSelectDropDownModule,
        ReactiveFormsModule,
        FormsModule,
        FeatherModule,
        NgbModalModule,
        FeatherModule.pick(icons),
        RouterModule.forChild(routes),
        NgbPaginationModule,
        SharedModule,
        StampeModule,
        TranslateModule,
        MappaModule,
        PdfViewerModule,
        DragDropModule,
        TooltipModule,
    ]
})
export class RMAModule { }
